export default {
   // Promotions Admin
  "userPromotionsAdmin.add": "Add",
  "userPromotionsAdmin.details": "Details",
  "userPromotionsAdmin.edit": "Edit",
  "userPromotionsAdmin.delete": "Delete",
  "userPromotionsAdmin.delete.confirm.title": "Delete Configuration",
  "userPromotionsAdmin.delete.confirm.content": "Are you sure you want to delete this configuration?",
  "userPromotionsAdmin.delete.confirm.okText": "Confirm",
  "userPromotionsAdmin.delete.confirm.cancelText": "Cancel",
  "userPromotionsAdmin.modal.title": "Promotion Configuration",
  "userPromotionsAdmin.thead.createdAt": "Created At",
  "userPromotionsAdmin.thead.updatedAt": "Updated At",
  "userPromotionsAdmin.thead.action": "Action",

  // Bargain Turntable fields
  "userPromotionsAdmin.thead.target": "Target",
  "userPromotionsAdmin.thead.expireDays": "Expire Days",
  "userPromotionsAdmin.thead.loginChance": "Login Chance",
  "userPromotionsAdmin.thead.referralChance": "Referral Chance",
  "userPromotionsAdmin.thead.totalSpin": "Total Spin",

  // Bargain Turntable tooltips
  "userPromotionsAdmin.tips.target": "Explain the target type or object for the wheel.",
  "userPromotionsAdmin.tips.expireDays": "Validity days for rewards/chances. They expire after this period.",
  "userPromotionsAdmin.tips.loginChance": "Daily spins obtained from user login.",
  "userPromotionsAdmin.tips.referralChance": "Extra spins granted after successful referrals.",
  "userPromotionsAdmin.tips.totalSpin": "Maximum total spins allowed during the campaign.",

  // Promotion fields
  "userPromotionsAdmin.thead.id": "ID",
  "userPromotionsAdmin.thead.documentId": "Document ID",
  "userPromotionsAdmin.thead.sort": "Sort",
  "userPromotionsAdmin.thead.itemName": "Item Name",
  "userPromotionsAdmin.thead.itemId": "Item ID",
  "userPromotionsAdmin.thead.content": "Content",
  "userPromotionsAdmin.thead.listToDdetailText": "Detail Text",
  "userPromotionsAdmin.thead.listOpenType": "Open Type",
  "userPromotionsAdmin.thead.listOpenUrl": "Open Url",
  "userPromotionsAdmin.thead.openPaymentBindBonusId": "Bind Bonus ID",
  "userPromotionsAdmin.thead.itemSubName": "Sub Name",
  "userPromotionsAdmin.thead.isMessage": "Is Message",
  "userPromotionsAdmin.thead.publishedAt": "Published At",
  "userPromotionsAdmin.thead.locale": "Locale",
  "userPromotionsAdmin.thead.banner": "Banner",
  "userPromotionsAdmin.thead.seo": "SEO",
  "userPromotionsAdmin.thead.listTitleIcon": "Title Icon",
  "userPromotionsAdmin.thead.bindSite": "Bind Site",
  "userPromotionsAdmin.thead.createdBy": "Created By",
  "userPromotionsAdmin.thead.updatedBy": "Updated By",
  "userPromotionsAdmin.thead.localizations": "Localizations",
  "userPromotionsAdmin.thead.status": "Status",

  // Added fields localization
  "userPromotionsAdmin.thead.startTime": "Start Time",
  "userPromotionsAdmin.thead.endTime": "End Time",
  "userPromotionsAdmin.thead.active": "Active",
  "userPromotionsAdmin.thead.userGroupRules": "User Group Rules",
  "userPromotionsAdmin.thead.vipRules": "VIP Rules",
  "userPromotionsAdmin.thead.channels": "Channels",
  "userPromotionsAdmin.thead.participationWay": "Participation Way",
  "userPromotionsAdmin.thead.bonusPayoutStrategy": "Bonus Payout Strategy",
  "userPromotionsAdmin.vipRules.all": "All Levels",
  // Option labels
  "userPromotionsAdmin.participationWay.auto": "Auto",
  "userPromotionsAdmin.participationWay.signUp": "Sign Up",
  "userPromotionsAdmin.bonusPayoutStrategy.auto": "Auto",
  "userPromotionsAdmin.bonusPayoutStrategy.manual": "Manual",
  "userPromotionsAdmin.bonusPayoutStrategy.userCollection": "User Collection",

  // Active/Deactive confirm texts (modeled after deposit-bonus-admin)
  "userPromotionsAdmin.active.confirm.title": "Activate Configuration",
  "userPromotionsAdmin.active.confirm.content": "Are you sure you want to activate this configuration?",
  "userPromotionsAdmin.active.confirm.okText": "Confirm",
  "userPromotionsAdmin.deactive.confirm.title": "Deactivate Configuration",
  "userPromotionsAdmin.deactive.confirm.content": "Are you sure you want to deactivate this configuration?",
  "userPromotionsAdmin.deactive.confirm.okText": "Confirm",

  // SEO fields
  "userPromotionsAdmin.thead.metaTitle": "Meta Title",
  "userPromotionsAdmin.thead.metaDescription": "Meta Description",
  "userPromotionsAdmin.thead.metaImage": "Meta Image",
  "userPromotionsAdmin.thead.keywords": "Keywords",
  "userPromotionsAdmin.thead.metaRobots": "Meta Robots",
  "userPromotionsAdmin.thead.metaViewport": "Meta Viewport",
  "userPromotionsAdmin.thead.canonicalURL": "Canonical URL",
  "userPromotionsAdmin.thead.structuredData": "Structured Data"
};
